import { render, staticRenderFns } from "./RVModification.vue?vue&type=template&id=12556d32&scoped=true"
import script from "./RVModification.vue?vue&type=script&lang=js"
export * from "./RVModification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12556d32",
  null
  
)

export default component.exports